import React from 'react';
import { View, Text, FlatList, RefreshControl } from 'react-native';
import { connect } from 'react-redux';
import queryString from 'query-string';

import Colors from "../../constants/Colors";
import {GET_USER_JOURNEYS_LOG} from "../../api/userEndpoints";
import get from "../../api/methods/get";
import {formatDate} from "../../constants/formatDate";
import NavBar from "../../components/NavBar";
import {SpinnerControl} from "../../components";

class PerformanceDetailsJourney extends React.Component {

    state = {
        dataToRender: null,
        isFetching: false,
    }

    fetchData = async () => {
        if (this.state.isFetching) return;
        this.setState({ isFetching: true });

        try {
            const userId = this.props.userId;
            const values = queryString.parse(this.props.location.search);
            const journeyId = values.journeyId;
            const endpoint = GET_USER_JOURNEYS_LOG(userId, journeyId);
            const result = await get(endpoint);
            const json = await result.json();

            const sortedData = json.data.Items.sort((a, b) => {
                return new Date(b.createdAt) - new Date(a.createdAt);
            })

            this.setState({ dataToRender: sortedData });

        } catch (e) {
            console.log(e);
        }

        this.setState({ isFetching: false });
    }

    componentDidMount() {
        this.fetchData();
    }

    render() {
        return (
            <NavBar style={{ flex: 1, backgroundColor: Colors.backgroundColor }}>

                <SpinnerControl isFetching={this.state.isFetching} text={"Carregando logs da jornada!"} />

                <View style={{ width: 600 }}>
                    <FlatList
                        data={this.state.dataToRender}
                        renderItem={({item}) => {
                            let title = item.contentTitle;
                            if (item.SK.includes("SUBSCRIPTION")) title = "Inscrição"
                            if (item.SK === "COMPLETE") title = "Completo"

                            const date = formatDate(item.createdAt)

                            return (
                                <View style={{ borderBottomWidth: 0.4, borderColor: 'gray', marginBottom: 12, padding: 8 }}>

                                    <Text style={{ fontSize: 22, color: Colors.fontColorOnBackground }}>
                                        { title }
                                    </Text>

                                    {
                                        item.pointsAwarded !== undefined &&
                                        <Text style={{ fontSize: 18, color: Colors.fontColorOnBackground }}>
                                            { `Pontos: ${item.pointsAwarded}` }
                                        </Text>
                                    }

                                    <Text style={{ fontSize: 18, color: Colors.fontColorOnBackground }}>
                                        { `Realizado em: ${date}` }
                                    </Text>

                                </View>
                            )


                        }}
                        keyExtractor={item => item.SK.toString()}
                        refreshControl={
                            <RefreshControl
                                refreshing={this.state.isFetching}
                                onRefresh={() => this.fetchData()}
                                colors={[Colors.spinnerColor]}
                                title={"Carregando performance na jornada!"}
                            />
                        }
                    />
                </View>

            </NavBar>
        )
    }
}

const mapStateToProps = state => {
    return {
        userId: state.user.userId,
    }
}

export default connect(mapStateToProps)(PerformanceDetailsJourney);
